"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _default = function _default() {
  return _react.default.createElement(_UIErrorMessage.default, {
    className: "playbook-not-published-state",
    illustration: "warning",
    illustrationProps: {
      width: 200
    },
    title: _I18n.default.text('playbooksModal.playbookNotPublished.title')
  }, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: "playbooksModal.playbookNotPublished.message"
  })));
};

exports.default = _default;
module.exports = exports.default;